var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardTrend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71307 4.37993L4.99203 3.96499L4.59806 3.70012L4.31314 4.07984L4.71307 4.37993ZM9.37331 7.51297L9.09434 7.92792L9.5075 8.20568L9.78704 7.79373L9.37331 7.51297ZM14.284 0.905991C14.2321 0.634776 13.9701 0.457011 13.6989 0.508942L9.27919 1.35521C9.00797 1.40714 8.83021 1.66911 8.88214 1.94032C8.93407 2.21154 9.19603 2.3893 9.46725 2.33737L13.3959 1.58513L14.1481 5.51376C14.2001 5.78498 14.462 5.96274 14.7332 5.91081C15.0044 5.85888 15.1822 5.59692 15.1303 5.3257L14.284 0.905991ZM1.49748 9.49843L5.113 4.68002L4.31314 4.07984L0.697619 8.89825L1.49748 9.49843ZM4.4341 4.79487L9.09434 7.92792L9.65227 7.09803L4.99203 3.96499L4.4341 4.79487ZM9.78704 7.79373L14.2067 1.28078L13.3792 0.719265L8.95957 7.23222L9.78704 7.79373Z",
    fill: "#23A818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardTrend);
export default __webpack_public_path__ + "static/media/forwardTrend.e7986dc9a354b2874a359a33a015476d.svg";
export { ForwardRef as ReactComponent };